import React, {Component} from 'react'
import { auth } from '../../firebase';
import { Button } from 'semantic-ui-react'
import {connect} from "react-redux";
import {resetAllStates} from "../../../Actions/ResetAllStates";
import { push } from 'react-router-redux'
import staticAppUrl from "../../../Constants/staticAppUrl";
import { setCookie } from "../../../Constants/setCookie";

class SignOutButton extends Component{
    constructor(props){
        super(props);

        this.signOut = this.signOut.bind(this);
    }

    signOut(e){
        setCookie("apispreadsheetsEmail", "", -1);
        setCookie("apispreadsheetsToken", "", -1);
        auth.doSignOut()
        this.props.resetAllStates();
        // if (this.props.isProductImporter){
        //     this.props.navigateTo(staticAppUrl)
        // } else {
        //     this.props.navigateTo(staticAppUrl)
        // }

        window.location.href = staticAppUrl;

    }

    render(){
        return(
            <div>
                <Button
                    // color="orange"
                        id="signOutButton" onClick={this.signOut}>Logout</Button>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    isProductImporter: state.mainState.isProductImporter
})

const mapActionsToProps = {
    resetAllStates: resetAllStates,
    navigateTo: push
}

export default connect(mapStateToProps, mapActionsToProps)(SignOutButton)